import { create } from "zustand";

/**
 * 알림장 목록 화면 상태 스냅샷.
 * 상세(알림 내용/예약 정보/글쓰기)로 이동하기 직전에 저장해 두고,
 * 뒤로가기로 목록에 돌아왔을 때:
 *   1) 저장된 페이지 수만큼(page * 10)을 한 번에 재조회하고
 *   2) 리스트가 그려지면 저장된 위치로 부드럽게 스크롤한다.
 * returning 플래그가 없으면(= 네비게이션 등 일반 진입) 복원하지 않고 새로 조회한다.
 */
export interface InformListSnapshot {
  tab: string;
  scrollY: number;
  /** 클릭했던 알림(notiRecvSeq) — 복원 시 이 카드가 화면 중앙에 오도록 스크롤 (없으면 scrollY 사용) */
  anchorSeq?: number | null;
  pageReceiver: number;
  pageSender: number;
}

interface InformListStore {
  returning: boolean;
  snapshot: InformListSnapshot | null;
  save: (snapshot: InformListSnapshot) => void;
  /** 복원 1회 소비 — 이후 일반 진입은 새로 조회 */
  consume: () => void;
}

export const useInformListStore = create<InformListStore>((set) => ({
  returning: false,
  snapshot: null,
  save: (snapshot) => set({ snapshot, returning: true }),
  consume: () => set({ returning: false }),
}));
